import type { RefObject } from 'react';
import React, { useEffect, useState } from 'react';

import * as styles from './image-loading-skeleton.module.scss';

type ImageLoadingSkeletonProps = {
  imageRef: RefObject<HTMLImageElement | null>;
  showLoadingSkeleton?: boolean;
};

const ImageLoadingSkeleton: React.FC<ImageLoadingSkeletonProps> = ({
  imageRef,
  showLoadingSkeleton,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const image = imageRef?.current;

    const hideImageSkeleton = () => {
      setIsLoading(false);
    };

    if (!image) return;

    if (image.complete) {
      hideImageSkeleton();
    } else {
      image.addEventListener('load', hideImageSkeleton);
      image.addEventListener('error', hideImageSkeleton);
    }

    return () => {
      image?.removeEventListener('load', hideImageSkeleton);
      image?.removeEventListener('error', hideImageSkeleton);
    };
  }, [imageRef]);

  const conditionToShow = showLoadingSkeleton ?? isLoading;

  return (
    conditionToShow && <div data-testid="image-loading-skeleton" className={styles.skeleton} />
  );
};

export default ImageLoadingSkeleton;
